export enum FeeServiceEnum {
    PIX_CASHIN_PERCENTUAL = 'pixCashin_percentual',
    PIX_CASHIN_VALOR = 'pixCashin_valor',
    PIX_STATIC_CASHIN = 'pixStaticCashin',
    BOLETO_CASHIN = 'boletoCashin',
    PIX_CASHOUT = 'pixCashout',
    PIX_CASHIN_SEM_STATUS = 'pixCashinSemStatus'
}